import { TextEditorWithLabelProps } from 'interfaces';
import { lazy, Suspense, useState } from 'react';
import { t } from 'services/i18n.service';
import HelpFilled from 'assets/icons/HelpFilled';
import Tooltip from './Tooltip';
import { RICH_TEXT_EDITOR_HEIGHT } from 'constants/general';
import { ATTRIB } from 'constants/test';

const TextEditor = lazy(() => import('components/common/TextEditor'));

export default function RichTextEditorWithLabel({
  label,
  tooltip,
  handleChange,
  value,
  required
}: TextEditorWithLabelProps) {
  const [hasTextLimitBeenReached, setHasTextLimitBeenReached] = useState(false);

  return (
    <>
      <div className='flex'>
        <h6 className='text-xs pb-0.5 text-gray-600 font-semibold mr-2'>
          {label}
        </h6>
        <Tooltip message={tooltip} icon={<HelpFilled />} />
        {hasTextLimitBeenReached && (
          <p className='text-red-400 text-xs ml-2'>{t('text_limit_reached')}</p>
        )}
      </div>
      <Suspense
        fallback={
          <div
            className={`w-full h-[${RICH_TEXT_EDITOR_HEIGHT.ROUTINE}px] flex items-center`}>
            <p className='~text-sm/base'>{t('loading_text_editor')}</p>
          </div>
        }>
        <TextEditor
          data-testid={ATTRIB.DATA_TESTID.RICH_TEXT_EDITOR}
          textMarkup={value}
          onTextChange={handleChange}
          setHasTextLimitBeenReached={setHasTextLimitBeenReached}
          required={required}
          height={RICH_TEXT_EDITOR_HEIGHT.ROUTINE}
        />
      </Suspense>
    </>
  );
}
